import * as React from 'react';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import AiAssistantsModal from './AiAssistantsModal';

function ChatAssistants({data} :any) {
  return (
    <div className="col-md-4 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">AI Assistants</h4>
          <p className="card-description"><AiAssistantsModal message="Learn more" /></p>

            <p className="card-description">
              <div className="media">
                <i className="mdi mdi-earth icon-md text-info d-flex align-self-start mr-3">
                  <AutoAwesomeIcon />
                </i>
                <div className="media-body">
                  <p className="card-text">Analyze and research {data.company_name}'s stock with <a href={"/financial_analyst/" + data.ticker + "/chat/lima"}>Lima</a>, our AI Analyst/Assistant.</p>
                </div>
              </div>
            </p>
            <p className="card-description">
              <div className="media">
                <i className="mdi mdi-earth icon-md text-info d-flex align-self-start mr-3">
                  <RecordVoiceOverIcon />
                </i>
                <div className="media-body">
                  <p className="card-text">Discuss, review, and analyze {data.company_name}'s SEC filings and earnings call transcripts with our AI Research Assistants, <a href={"/sec_filings/" + data.ticker}>June</a> and <a href={"/earnings_call_list/" + data.ticker}>Saturday</a>.</p>
                </div>
              </div>
            </p>
        </div>
      </div>
    </div>
  );
}

export default ChatAssistants;
